export const PromiseTypeSuffixes = [
  'pending', 'completed', 'rejected'
];
